import React from 'react';
import { Link } from 'react-router-dom';

const BankAccountsSection = ({ bankAccounts, companyId, formatCurrency, style }) => {
    return (
        <div className="dashboard-section" style={style}>
            <div className="d-flex align-items-center mb-4">
                <div className="dashboard-section-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ color: 'var(--primary)' }}>
                        <rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="2" />
                        <path d="M7 15h0M2 10h20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </div>
                <h5 className="mb-0 fw-semibold dashboard-section-title">Bankkonton</h5>
            </div>

            {/* Total balance card */}
            <div className="dashboard-summary-card" style={{ marginBottom: '1rem' }}>
                <div className="dashboard-summary-label" style={{ marginBottom: '0.25rem' }}>Total tillgängligt saldo</div>
                <div className="dashboard-metric-value">
                    {formatCurrency(bankAccounts.totalBalance)}
                </div>
                <div className="dashboard-summary-label" style={{ marginTop: '0.25rem', fontSize: '0.75rem' }}>
                    {bankAccounts.accounts.length} {bankAccounts.accounts.length === 1 ? 'konto' : 'konton'}
                </div>
            </div>

            {/* Individual accounts
            <div className="row">
                {bankAccounts.accounts.map((account) => (
                    <div key={account.accountNumber} className="col-md-6 mb-2">
                        <div className="dashboard-status-item">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', textAlign: 'left' }}>
                                <div>
                                    <div className="dashboard-summary-value" style={{ fontSize: '0.875rem', marginBottom: '0.125rem' }}>
                                        {account.accountName}
                                    </div>
                                    <div className="dashboard-summary-label" style={{ fontFamily: 'monospace' }}>
                                        {account.accountNumber}
                                    </div>
                                </div>
                                {account.bankName && (
                                    <span className="dashboard-metric-change--no-data" style={{
                                        fontSize: '0.65rem',
                                        padding: '0.125rem 0.5rem'
                                    }}>
                                        {account.bankName}
                                    </span>
                                )}
                            </div>
                            <div className="dashboard-status-value--primary" style={{ fontSize: '1.125rem', fontWeight: 700, marginTop: '0.5rem', textAlign: 'left' }}>
                                {formatCurrency(account.balance)}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
             */}

            {/* Bank actions 
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5rem', marginTop: '0.75rem' }}>
                <Link to={`/${companyId}/transactions/import`} className="dashboard-action-btn">
                    Importera transaktioner
                </Link>
                <Link to={`/${companyId}/bank-reconciliation`} className="dashboard-action-btn">
                    Bankavstämning
                </Link>
                <Link to={`/${companyId}/accounts`} className="dashboard-action-btn">
                    Kontoplan
                </Link>
            </div>
            */}
        </div>
    );
};

export default BankAccountsSection;
